import { Column } from 'src/app/shared/components/custom-table/enums/column.enum';
import { IColumn } from 'src/app/shared/components/custom-table/models/column.model';

export class ReportTableColumns {
    constructor(
        public code: string,
        //public reportTypeName: string,
        public creator: string,
        public auditType: string,
        public reportStatus: string,
        public createdAt: string,
        public closedAt?: string,
        public id?: string,
        public reportStatusCode?: string,
        public creatorId?: number
    ) {}
}
export class ReportDevicesTableColumns {
    constructor(
        public serialNumber: string,
        public capacity: string,
        public deviceName: string,
        public ownerId: number,
        public ownerName: string,
        public departmentId: number,
        public departmentName: string,
        public departmentCode: string,
        public requestDate: string,
        public returnedDate: string,
        public deliveryDate: string,
        public reportStatusName: string,
        public reportStatusCode: string,
        public id?: string,
        public ownerImage?: string,

    ) {}
}
export class ReportDevicesChangedTableColumns {
    constructor(
        public field: string,
        public oldValue: string,
        public newValue: string,
        public userId: number,
        public userName: string,
        public userEmail: string,
        public userImage: string,
        public changeSource: string,
        public createdAt: string,
        public id?: string,


    ) {}
}

export const REPORT_VIEW_DISPLAYED_COLUMNS: IColumn[] = [
    {
        label: 'Report Code',
        path: 'code',
        type: Column.Text,
        isTruncated: true,
        truncatedWidth: '100'
    },
    {
        label: 'Report Name',
        path: 'reportTypeName',
        truncatedWidth: '100',
        type: Column.Text,
        isFiltration:true,
        filtrationList:[],
        filtrationKey:'filter[report-type-ids]'
    },
    {
        label: 'Auditor',
        path: 'creator',
        type: Column.Text,
        isTruncated: true,
        truncatedWidth: '100',
        isFiltration: true,
        filtrationList: [],
        filtrationKey: 'filter[creator-ids]'
    },
    {
        label: 'Type',
        path: 'auditType',
        type: Column.Text,
        isFiltration: true,
        filtrationList: [],
        filtrationKey: 'filter[audit-type-ids]'
    },
    {
        label: 'Creation Date',
        path: 'createdAt',
        truncatedWidth: '100',
        type: Column.Date,
        format: 'd MMM YYYY - h:mm a',
        isSortable: true
    },
    {
        label: 'Status',
        path: 'reportStatus',
        truncatedWidth: '100',
        type: Column.Content,
        contentIndex: 0,
        isFiltration:true,
        filtrationList:[],
        filtrationKey:'filter[status-ids]'
    },
    {
        label: 'Actions',
        path: 'actions',
        truncatedWidth: '100',
        type: Column.Content,
        contentIndex: 1
    }
];
